<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Expense Items Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Expense Items Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "item",
          label: "Expense Item",
          sortable: true,
        },
        {
          key: "date",
          label: "Expense Date",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "supplier",
          label: "Supplier",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "record",
          label: "Recorded On",
          sortable: true,
        },
        {
          key: "user",
          label: "Recorded By",
          sortable: true,
        },
      ],
      data: {
        supplier: 0,
        item: 0,
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      assigned: [],
    };
  },
  computed: {
    ...mapGetters("expenses", [
      "Suppliers",
      "DetailReport",
      "ExpenseItems",
      "SaveStatus",
    ]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    DetailReport(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchDetailReport",
      FetchSuppliers: "expenses/fetchSuppliers",
      FetchItems: "expenses/fetchExpenseItems",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    fetch_expenses() {
      this.FetchExpenses(this.data);
    },
    assign() {
      this.assigned = this.DetailReport;
    },
  },
  created() {
    this.FetchSuppliers();
    this.FetchItems();
    this.FetchExpenses(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Supplier</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.supplier">
                    <option value="0">All Suppliers</option>
                    <option
                      v-for="(t, index) in Suppliers"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label>Item</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.item">
                    <option value="0">All Items</option>
                    <option
                      v-for="(t, index) in ExpenseItems"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <label>From</label>
                <div class="input-group">
                  <input type="date" v-model="data.from" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <label>To</label>
                <div class="input-group">
                  <input type="date" v-model="data.to" class="form-control" />
                </div>
              </div>
              <div class="col-md-2 mt-2">
                <br />
                <button class="btn btn-success" @click="fetch_expenses()">
                  <i class="fa fa-search"></i> Search
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned.expenses : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <input
                    type="text"
                    class="form-control custom"
                    v-model="data.item.amount"
                    @input="addPreviousDebt($event.target.value, data.item.id)"
                  />
                </template>
              </b-table>
              <table
                width="100%"
                style="border-top: 1px solid #ccc; border-bottom: 1px solid #ccc"
              >
                <tr>
                  <td width="50%"><h2>TOTAL</h2></td>
                  <td width="50%">
                    <h2>{{ assigned.tot }}/=</h2>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
